/**
 * Dynamically loads the Lucky Orange analytics script if configured.
 * This replaces the inline script that was previously in index.html.
 */
export const loadLuckyOrange = (): void => {
  const siteId = import.meta.env.VITE_LUCKY_ORANGE_SITE_ID;

  // Check if siteId is defined and not a placeholder
  if (siteId && siteId !== "%VITE_LUCKY_ORANGE_SITE_ID%") {
    console.log("Lucky Orange is enabled");

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = `https://tools.luckyorange.com/core/lo.js?site-id=${siteId}`;

    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }
  }
};
